import Check from "@material-ui/icons/Check";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { returnLanguage } from "../../utils/prepareValues";
import { DialogBuilder } from "~/utils/DialogProvider";
import useStyles from "./styles";

const VendorCategorieScheduling = (props) => {
	const [selectedCategorie, setSelectedCategorie] = useState(null);
	const classes = useStyles({ selectedCategorie });
	const dialog = useContext(DialogBuilder);
	const { t, i18n } = useTranslation();
	const pet = props?.selectedPet;
	const coupon = props?.location?.state?.coupon;
	const selectCategory = props?.selectCategory;
	const business = props.business;
	const storageLanguage = sessionStorage.getItem("@prit-web/language");
	const language = storageLanguage ?? business?.language;

	const [categoriesList, setCategoriesList] = useState([]);

	const goToNextPage = (category) => {
		// Salva apenas a imagem da categoria, não a categoria inteira
		sessionStorage.setItem("imageCategory", JSON.stringify(category?.image));
		
		// Dispara custom event para notificar mudança no sessionStorage
		window.dispatchEvent(new CustomEvent('customStorageChange', {
			detail: { key: 'imageCategory', value: category?.image }
		}));
		
		selectCategory({ categorie: category, pet: pet, coupon: coupon });
	};

	useEffect(() => {
		sessionStorage.removeItem("selectedCategory");
		if (business?.categories) {
			if (business.categories.length > 1) {
				setCategoriesList(business.categories.sort((a, b) => (a?.name < b?.name ? -1 : 1)));
			} else {
				goToNextPage(business.categories[0]);
			}
		}
	}, []);

	return (
		<Fragment>
				<div>
					{categoriesList?.length > 0 && (
						<div className={classes.containerCategories}>
							{categoriesList.map((item) => {
								return (
									<div
										key={item?.id}
										className={classes.boxCategorie}
										style={{
											position: "relative",
											backgroundImage: !selectedCategorie
												? `url(${item?.image})`
												: selectedCategorie?.id === item?.id
												? `linear-gradient(to top, rgba(0, 0, 0, 0.6) 100%, rgba(0, 0, 0, 0)), url(${item?.image})`
												: `linear-gradient(to top, rgba(255, 255, 255, 0.6) 100%, rgba(0, 0, 0, 0)), url(${item?.image})`,
											backgroundSize: "150%",
											backgroundRepeat: "no-repeat",
										}}
										onClick={() => {
											setSelectedCategorie(item);
											goToNextPage(item);
										}}>
										{selectedCategorie?.id === item?.id && (
											<Check
												style={{
													marginTop: "38%",
													fontSize: "40px",
													alignSelf: "center",
													width: "100%",
													color: "#fff",
												}}
												className={classes.checkCategory}
											/>
										)}
										<div
											style={{
												position: "absolute",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												height: "calc(30vw*0.3)",
												maxHeight: "32px",
												background: "#fff",
												bottom: 0,
												borderRadius: "0px 0px 7% 7%",
												width: "100%",
												backgroundColor: selectedCategorie?.id === item?.id ? "transparent" : "#FBEFD7",
											}}>
											<h1
												translate="no"
												className={classes.nameCategorieSelection}
												style={{ color: selectedCategorie?.id === item?.id ? "#fff" : "#222" }}>
												{item?.name}
											</h1>
										</div>
									</div>
								);
							})}
						</div>
					)}
				</div>
		</Fragment>
	);
};
export default withRouter(VendorCategorieScheduling);
